import {
  EyeStroke,
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onViewClick?: () => void;
  onRefreshClick?: () => Promise<void>;
  isEditDisabled?: boolean;
  isViewDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isCopyDisabled?: boolean;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onRefreshClick,
  isEditDisabled = false,
  isViewDisabled = false,
  isDeleteDisabled = false,
  isCopyDisabled = false,
  onFixedColumnsClick,
  onExportClick
}) => (
  <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục khế ước</h1>}>
    {onAddClick && <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} />}
    {onEditClick && <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isEditDisabled} />}
    {onDeleteClick && (
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isDeleteDisabled} />
    )}
    {onCopyClick && (
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={isCopyDisabled} />
    )}
    {onViewClick && <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled} />}
    {onRefreshClick && <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={onRefreshClick} />}
    {onFixedColumnsClick && (
      <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onFixedColumnsClick} />
    )}

    <MenuButtonV2
      items={[
        {
          title: 'Kết xuất dữ liệu',
          icon: <AritoIcon icon={555} />,
          onClick: onExportClick,
          group: 0
        },
        {
          title: 'Tải mẫu excel',
          icon: <AritoIcon icon={28} />,
          onClick: () => {},
          group: 1
        },
        {
          title: 'Lấy dữ liệu từ excel',
          icon: <AritoIcon icon={29} />,
          onClick: () => {},
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);

export default ActionBar;
